import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
//
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableHead from "@mui/material/TableHead";
import TableFooter from "@mui/material/TableFooter";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableRow from "@mui/material/TableRow";
import TablePagination from "@mui/material/TablePagination";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import { makeStyles, styled } from "@material-ui/styles";
//
import isFunction from "lodash/isFunction";
import isNumber from "lodash/isNumber";
//
import classNames from "classnames";
import EnhancedTableHead from "./Table/EnhancedTableHead";
import TablePaginationActions from "./Table/TablePaginationActions";
import CustomTableCell from "./Table/CustomTableCell";
import { MARK_STYLE, FONT_SIZE } from "./option";

const StyledPaper = styled(Paper)(({ theme }) => ({
  // width: "100%",
  // height: "100%",
}));

const StyledTableContainer = styled(TableContainer)(({ theme }) => ({
  maxHeight: "350px",
  minHeight: "300px",
}));

const StyledTable = styled(Table)(({ theme }) => ({
  minWidth: 100,
}));

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === "desc"
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort(array, comparator) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}

const defaultRowsPageOption = [5, 10, 15, { label: "All", value: -1 }];

const NormalDisplay = (props) => {
  // props
  const {
    curResult,
    headers,
    keyword,
    getKeyword,
    markStyle,
    fontSize,
    forceResetPage,
    onPageChange,
    page,
    rowsPerPage,
    rowsPerPageOptions,
    onRowsPerPageChange,
    dataUniqKey = "id",
    dataChangeSignal,
    onCurPageRowsChange,
    tableContainerClassName,
  } = props;
  // style
  // local state
  const [localPage, setLocalPage] = useState(page || 0);
  const [localRowsPerPage, setLocalRowsPerPage] = useState(rowsPerPage || 5);
  const [localRowsPerPageOptions, setLocalRowsPerPageOptions] = useState(
    rowsPerPageOptions || defaultRowsPageOption
  );
  const [rows, setRows] = useState([]);
  const [order, setOrder] = useState("asc");
  const [orderBy, setOrderBy] = useState("calories");
  const [curPageRows, setCurPageRows] = useState([]);
  const [curPageRowsKey, setCurPageRowsKey] = useState("");

  useEffect(() => {
    if (Array.isArray(curResult)) {
      setRows(curResult);
      if (forceResetPage) {
        setLocalPage(0);
      }
    }
  }, [curResult]);

  useEffect(() => {
    if (isNumber(page)) setLocalPage(page);
  }, [page]);

  useEffect(() => {
    // 當前頁面的資料變更時, 通知 parent
    const curPageData = stableSort(rows, getComparator(order, orderBy)).slice(
      localPage * localRowsPerPage,
      localPage * localRowsPerPage + localRowsPerPage
    );
    setCurPageRows(curPageData);
    const uniqData = curPageData
      .map((o) => o?.[dataUniqKey])
      .filter((t) => !!t);
    const uniqKeyStr =
      JSON.stringify(uniqData.concat([dataChangeSignal])) + dataChangeSignal;
    if (uniqKeyStr !== curPageRowsKey) {
      setCurPageRowsKey(uniqKeyStr);
      if (isFunction(onCurPageRowsChange)) onCurPageRowsChange(curPageData);
    }
  }, [rows, order, orderBy, localPage, localRowsPerPage, dataChangeSignal]);

  const emptyRows =
    localRowsPerPage -
    Math.min(localRowsPerPage, rows.length - localPage * localRowsPerPage);

  // eslint-disable-next-line no-unused-vars
  const handleChangePage = (event, newPage) => {
    setLocalPage(newPage);
    if (isFunction(onPageChange)) onPageChange(newPage);
  };

  // eslint-disable-next-line no-unused-vars
  const handleChangeRowsPerPage = (event) => {
    const { value } = event.target || {};
    const tmpRowsPerPage = parseInt(value, 10);
    setLocalRowsPerPage(tmpRowsPerPage);
    setLocalPage(0);
    if (isFunction(onRowsPerPageChange)) onRowsPerPageChange(tmpRowsPerPage);
    // 當 使用者變更每頁筆數時, handleChangeRowsPerPage 先於 handleChangePage 也會被呼叫
    // 為了讓 parent 重新計算 limit, offset, 所以 除了通知 newPage, 另外加上 localRowsPerPage
    if (isFunction(onPageChange)) onPageChange(0, tmpRowsPerPage);
  };

  const handleClickLink = () => {
    // console.log(e);
  };

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  return (
    <StyledPaper>
      <StyledTableContainer className={classNames(tableContainerClassName)}>
        <StyledTable stickyHeader aria-label="sticky table">
          <EnhancedTableHead
            onRequestSort={handleRequestSort}
            order={order}
            orderBy={orderBy}
            headCells={Object.values(headers).filter((hd) => hd.display)}
          />
          <TableBody>
            {stableSort(rows, getComparator(order, orderBy))
              .slice(
                localPage * localRowsPerPage,
                localPage * localRowsPerPage + localRowsPerPage
              )
              .map((row, rowIdx) => (
                <TableRow hover tabIndex={-1} key={rowIdx}>
                  {Object.keys(headers)
                    .filter((header) => headers[header].display)
                    .map((hd, hdIdx) => (
                      <CustomTableCell
                        key={hdIdx}
                        header={headers[hd]}
                        rowData={row}
                        handleClickLink={handleClickLink}
                        fontSize={fontSize}
                        keyword={
                          keyword ||
                          (isFunction(getKeyword) &&
                            getKeyword(row, headers[hd]))
                        }
                        markStyle={headers[hd]?.markStyle || markStyle}
                      />
                    ))}
                </TableRow>
              ))}
            {emptyRows > 0 && (
              <TableRow style={{ height: 53 * emptyRows }}>
                <TableCell colSpan={6}>
                  <Box textAlign="center" my={5}>
                    <Typography variant="body1">以下無資料</Typography>
                  </Box>
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </StyledTable>
      </StyledTableContainer>
      {/* 把 TableFooter 拆出來, 讓它 always display */}
      <TableContainer>
        <Table>
          <TableFooter>
            <TableRow>
              <TablePagination
                rowsPerPageOptions={localRowsPerPageOptions}
                colSpan={3}
                count={(Array.isArray(curResult) && curResult.length) || 0}
                rowsPerPage={localRowsPerPage}
                page={localPage}
                SelectProps={{
                  inputProps: {
                    "aria-label": "rows per page",
                  },
                  native: true,
                }}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                ActionsComponent={TablePaginationActions}
              />
            </TableRow>
          </TableFooter>
        </Table>
      </TableContainer>
    </StyledPaper>
  );
};

NormalDisplay.defaultProps = {
  keyword: undefined,
  getKeyword: () => null,
  markStyle: undefined,
  fontSize: undefined,
  forceResetPage: true,
  onPageChange: () => null,
  page: undefined,
  rowsPerPage: undefined,
  rowsPerPageOptions: defaultRowsPageOption,
  dataUniqKey: "id",
  dataChangeSignal: "12345",
  onRowsPerPageChange: () => null,
  onCurPageRowsChange: () => null,
  tableContainerClassName: undefined,
};
NormalDisplay.propTypes = {
  /** 目前結果 */
  curResult: PropTypes.arrayOf(PropTypes.any).isRequired,
  /** table 表頭 */
  headers: PropTypes.objectOf(PropTypes.any).isRequired,
  /** 搜尋關鍵字:用於 highlight keyword */
  keyword: PropTypes.string,
  /** getKeyword */
  getKeyword: PropTypes.func,
  /** highlight 的樣式 */
  markStyle: PropTypes.oneOf(Object.keys(MARK_STYLE)),
  /** 樣式 */
  fontSize: PropTypes.string, // 1.2em
  /** 當 curResult 變動, 重設頁碼回到 0 */
  forceResetPage: PropTypes.bool,
  /** 當頁碼變更的 callback */
  onPageChange: PropTypes.func,
  /** 當前頁碼 */
  page: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  /** 每頁比數 */
  rowsPerPage: PropTypes.number,
  /** 每頁比數 option */
  rowsPerPageOptions: PropTypes.arrayOf(PropTypes.any),
  /** 每筆資料的 uniq key */
  dataUniqKey: PropTypes.string,
  /** curResult 有變更時的 singal */
  dataChangeSignal: PropTypes.string,
  /** 當每頁比數變更的 callback */
  onRowsPerPageChange: PropTypes.func,
  /** 當此頁資料變更的 callback */
  onCurPageRowsChange: PropTypes.func,
  /** tableContainer ClassName */
  tableContainerClassName: PropTypes.string,
};

export default NormalDisplay;
